import { render, staticRenderFns } from "./SettingPlanAddH.vue?vue&type=template&id=2cd2342c&scoped=true&"
import script from "./SettingPlanAddH.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAddH.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAddH.vue?vue&type=style&index=0&id=2cd2342c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2342c",
  null
  
)

export default component.exports